import { environment } from '../../../environments/environment';
import { isAgentRole, type AgentRole } from '../models/entities/agent-role.model';

/**
 * Temporary local-only role override.
 * TODO: remove before release — search `devRoleOverride` and delete this helper plus
 * the `environment.devRoleOverride` / hosted environment fields.
 */
export function applyDevRoleOverride(role: AgentRole | null): AgentRole | null {
  if (role == null || environment.production) {
    return role;
  }

  const override = environment.devRoleOverride;
  return isAgentRole(override) ? override : role;
}
